/** ArrayBuffer from axios responseType: 'arraybuffer' has byteLength, not size. */
export function isEmptyPdfPayload(data) {
  const len = data?.byteLength ?? data?.size ?? 0;
  return !data || len === 0;
}

export function axiosErrorMessage(err, fallback = 'Error in downloading invoice') {
  const data = err?.response?.data;
  if (data instanceof ArrayBuffer) {
    try {
      const decoded = new TextDecoder('utf-8').decode(data);
      try {
        const json = JSON.parse(decoded);
        return json?.message || decoded || fallback;
      } catch {
        if (decoded.includes('Customer details missing')) {
          return 'Customer details missing, please fill application form';
        }
        return decoded || fallback;
      }
    } catch {
      return err?.message || fallback;
    }
  }
  return data?.message || err?.message || fallback;
}

export function triggerPdfDownload(data, filename) {
  const blob = new Blob([data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}
